import { Directive, ElementRef, Input, inject } from '@angular/core';
import { AccessControlService } from '../services/access-control.service';
import { Router } from '@angular/router';
import { accessControlConstants } from '../constants/access-control-constants';
import { Utilities } from '../utils/utilities';

@Directive({
  selector: '[roleAccessControl]',
  standalone: true,
  exportAs: 'accessControl'
})
export class AccessControlDirective {
  @Input("accessType") accessType: any = null;
  @Input("fieldId") fieldId: any = null;
  @Input("accessPage") accessPage: any = [];
  @Input("popUpContent") popUpContent: string = '';
  @Input("pageType") pageType: string = '';
  util = inject(Utilities);
  accessService = inject(AccessControlService);
  router = inject(Router);
  accessControl: any = null;
  pageTypeBackup: string = '';

  constructor(public elementRef: ElementRef) { }

  ngOnInit() {
    this.handleInit();
  }

  handleInit(){
    if (this.pageType) this.accessService.pageType = this.pageType;
    this.popUpContent ? this.accessCheckForPopup() : this.accessCheck();
  }

  get userRole() {
    return this.util.getStoredUserDetails().roleName;
  }

  accessCheckForPopup() {
    this.pageTypeBackup = structuredClone(this.accessService.pageType);
    this.accessService.pageType = this.popUpContent;
    this.accessService.getAccessData(this.popUpContent);
    this.accessService.pageType = this.pageTypeBackup;
  }

  accessCheck() {
    this.accessControl = null;
    const pageAccessData = this.getAccessData(this.accessService.pageAccess$());
    const fieldAccessData = this.getAccessData(this.accessService.fieldAccess$());
    const actionAccessData = this.getAccessData(this.accessService.userActionAccess$());
    if (this.accessPage && pageAccessData) {
      const accessData = Object.keys(pageAccessData).find((access: string) => this.accessPage?.includes(access) && pageAccessData[access]);
      if (accessData)
        this.hideElement(accessData, 'pageAccess', pageAccessData);
    }
    if (this.accessType && actionAccessData && this.accessType in actionAccessData)
      this.hideElement(this.accessType, 'actionAccess', actionAccessData);
    if (this.fieldId && fieldAccessData) {
      this.accessType = accessControlConstants.fieldAccessList.find((access: string) => fieldAccessData[access]?.includes(this.fieldId));
      this.hideElement(this.accessType, 'fieldAccess');
    }
  }

  getAccessData(data: any) {
    const pageType = this.accessService.pageType;
    if (pageType in data)
      if (this.userRole in data[pageType])
        return data[pageType][this.userRole];
    return null;
  }

  hideElement(accessType: string, from: string, accessData?: any) {
    if (from === 'fieldAccess' || (accessData && accessData[accessType]))
      if (['hide']?.includes(accessType) && this.elementRef?.nativeElement?.style) this.elementRef.nativeElement.style.display = "none";
      else if (accessType) this.accessControl = accessType || '';

    if (from === 'actionAccess' && !this.accessControl && this.elementRef?.nativeElement?.style)
      this.elementRef.nativeElement.style.display = "none";
  }
}
